import React from 'react';
import styled , {keyframes} from 'styled-components';
import ImageGallery from 'react-image-gallery';

const GalleryContainer = styled.div`
    background-color: white;
    // margin-top: 50px;
    padding-bottom: 40px;
    position: relative;
    width: 100%;
    // opacity: 0.3;
     &:before,:after{
          position: absolute;
          content: '';
          pointer-events: none;
          color: black;
          top: -35px; 
          left: 0;
          z-index: 4; //must be less than 5 (z-index value of the gallery in fullscrean mode) otherwise will appear on top of the fullscrean
          width: 50%;
          height: 35px;
          background: white;
      }
      
      &:before{
        border-radius: 0 80px 0 0;
      }
      
      &:after{
        border-radius: 80px 0 0 0;
        left:50%;
      }   

      & > img{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: auto;
        opacity: 0.35;
        // object-fit: scale-down;
      }
`

const scaleAnimation = keyframes`
    0%{
        transform: scalex(1);
    }
    100%{
        transform: scalex(0);
    }
`

const Heading = styled.h2`
    // animation: ${scaleAnimation} 1.5s linear infinite alternate;
    // position: absolute;
    // left:-100px;
    color: black;
    transform-origin: 100% 50% 0;
    text-align: center;
`

const StyledGallery = styled(ImageGallery)`
    padding-top: 60px;
    width: 70%;
`
// const d = styled.div`
//     position: absolute;
//     left: 0;
//     top: 0;
//     width: 100%;
//     height: auto;
//     opacity: 0.45;
//     background-image: url('/marble-2398946_1920.jpg');
// `

export default function CardGallery({images,title}){

    //TODO: remove later and do this in the appropriate place
    // const galleryImages = images.map(image => {
    //     return {
    //         original: image.images.file ? image.images.file : image.images.lg,
    //         thumbnail: image.images.file ? image.images.file : image.images.sm
    //     }
    // });
    console.log(images)
    return(
        <GalleryContainer>
            {/* <img src={'images/marble-2398946_1920.jpg'}/>   */}
            {/* TODO add the image to some public place */}
            {/* <d/> */}
            <Heading>{title}</Heading>
            <StyledGallery 
                items={images}
                showThumbnails={false}
                showPlayButton={false}
                showBullets={true} 
                autoPlay={true}
                useBrowserFullscreen={false}
            />
        </GalleryContainer>
    )
}